// React imports.
import React from "react";

import { Assessment3bStepsEnum } from "../state";
import { Assessment3bDataReceivedStatusEnum } from "../state";


const Assessment3bTopParagraph = ({fuelType, state }) => (
    <div>
        {(fuelType.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.OverTargetNoIssues)
          &&  <p>

                <strong>
                    Status: No data reliability issue present!
                </strong>&nbsp;
                Your data for  {fuelType.description}   households have not been flagged in
                Assessment #3B because more than  {fuelType.targetPercentHouseholdsCoveredString}   of
                your  {fuelType.description}   households have 12 months
                of data received for both main heating fuel and
                electric baseload expenditures.
            </p>
        }
        {(fuelType.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.NoHouseholdsServed
            && fuelType.numHouseholds===0)
        &&
            <p>
                <strong>
                    Status: N/A -
                </strong>&nbsp;
                You indicated that you DO NOT serve households that
                heat with &nbsp;{fuelType.description}. Therefore,
                there is no data here to check. Please click next.
            </p>
        }
        {(fuelType.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.ElecticunderTarget)
          &&
          <p>
              <strong>
                  Status: Potential data reliability issue present!  
              </strong>&nbsp;
              Your data for  {fuelType.description}   households have been flagged because
              a sufficient number,  {fuelType.hHMainHeatDataReceivedPercentString}   of
              your  {fuelType.description}   households have 12 months of main
              heating data collected but an insufficient
              number,  {fuelType.hHElectricDataReceivedPercentString}  have
              12 months of electric baseload data.
          </p>
        }

        {(fuelType.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.MainHeatUnderTarget)
          &&
          <p>
              <strong>
                  Status: Potential data reliability issue present!  
              </strong>&nbsp;
              Your data for  {fuelType.description}   households have been flagged because
              a sufficient number,  {fuelType.hHElectricDataReceivedPercentString}   of
              your  {fuelType.description}   households have 12 months of electric
              data collected but an insufficient
              number,  {fuelType.hHMainHeatDataReceivedPercentString}  have
              12 months of main heating data.
          </p>
        }

        {(fuelType.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.HhWithBothUnderTarget)
          &&
          <p>
              <strong>
                  Status: Potential data reliability issue present!  
              </strong>&nbsp;
              Your data for  {fuelType.description}  households have been flagged
              because a sufficient number,  {fuelType.hHElectricDataReceivedPercentString}  of
              your  {fuelType.description}  households have 12 months of electric data
              collected, and a sufficient number,  {fuelType.hHMainHeatDataReceivedPercentString}  have
              12 months of heating data, but an insufficient
              number, {fuelType.hHBothDataReceivedPercentString} have both electric baseload
              and main heating data.  
          </p>
        }
        {(fuelType.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.EntryError)
          &&
          <p>
              <strong>
                  Status: Entry Error!  
              </strong>&nbsp;
              Your data for  {fuelType.description}  households have been flagged
              because they include a data entry error.  Please ensure that the number of households 
              for which each type of data was received does not exceed the total number of households.
          </p>
        }


        {(fuelType.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.NeitherOverTarget)
          &&
          <p>
              <strong>
                  Status: Potential data reliability issue present!  
              </strong>&nbsp;
              Your data for  {fuelType.description}  households have been flagged because
              you did not collect enough main heating data or electric baseload data
              for  {fuelType.description}  households.
          </p>
        }
    </div>
);

export default Assessment3bTopParagraph;
